import React, {useState} from "react";
import CookieConsent from "react-cookie-consent";
import { useSelector } from "react-redux";
import { TextField } from "../atoms/textfield";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import NewsLetterConfig from "../../../../config/newsletter";
import { subscribeToMailchimp } from "../pages/newsletter/api";
import { isValidEmail } from "../../utils";
import LoadingIcon from "../../../assets/images/loader.svg";
import "./newsletter-banner.m.css"
export default function NewsletterBanner(){

  const [showLoader, setShowLoader] = useState();
  const [email, setEmail] = useState();
  const [error, setError] = useState();
  const [subscribeMailStatus, setSubscribeMailStatus] = useState([]);

  const onChange = e => {
    setEmail(e.target.value);
    e.target.value ? setError("") : setError("Please provide Email !!");
  };

  const onSubmitClick = () =>{
    if (email) {
      if (!isValidEmail(email)) {
        setError("Invalid Email !!");
      } else {
        setShowLoader(true);
        subscribeToMailchimp({
          email: email,
          listId5: "aa2c780e6c"
        })
          .then(status => {
           setSubscribeMailStatus(status);
           setEmail("");
           
           setShowLoader(false);
           setTimeout(function() {
            setSubscribeMailStatus([]);
          }, 6000);
          })
          .catch((err) => {
            console.log(err)
          });
      } 
    } else {
      setError("Please provide Email !!");
     
    }
  }

  const domainSlug = useSelector(state => get(state, ["qt", "domainSlug"], null));
    if(!domainSlug)
        return null;
    else{
        return(
       
            <CookieConsent style={{backgroundColor:"#231f20", justifyContent:"center", maxWidth:"450px", float:"center"}} 
                buttonStyle={{
                  "position":"absolute", "top":"-24px", "right" : "-20px", backgroundColor:"#ec2227", color:"white",borderRadius:"50%",
                  width:"20px", height:"20px", "fontWeight":"var(--bold)",
                  backgroundImage:"url('https://img.icons8.com/windows/32/ffffff/macos-close.png')","backgroundPosition": "center"
                }} 
                buttonText=""
            >
                <div styleName="wrapper">
                  <div >
                    <h3 style={{"color":"#ec2227", fontWeight:"var(--semi-bold)"}}>न्यूज़लॉन्ड्री डाक</h3>
                    <small styleName="newsletter-text">न्यूज़लॉन्ड्री हिन्दी के साप्ताहिक संपादकीय, चुनिंदा बेहतरीन रिपोर्ट्स, टिप्पणियां और मीडिया की स्वस्थ आलोचनाएं. आपके इनबॉक्स में.</small>
                  </div>
               
                {showLoader === true && (
                    <div styleName="modal">
                      <div styleName="modal-content">
                        <img src={assetify(LoadingIcon)} alt="loading" />
                      </div>
                    </div>
                  )}
                <div styleName="subscribe-view-content " >
                    <TextField value={email} error={error} onChange={onChange} placeholder="Type your email" />
                    <button styleName="submit-btn" onClick={onSubmitClick}>
                        साइन अप 
                    </button>
                </div>
                {subscribeMailStatus && subscribeMailStatus.length > 0 && (
                    <div styleName="modal">
                      <div styleName="modal-content show-message">Thanks for signing up. See you in your inbox soon.</div>
                    </div>
                  )}
                  </div>
            </CookieConsent>
        )
    }
} 